import { render, staticRenderFns } from "./IconChevronDown.vue?vue&type=template&id=4d24b944&scoped=true"
import script from "./IconChevronDown.vue?vue&type=script&lang=ts"
export * from "./IconChevronDown.vue?vue&type=script&lang=ts"
import style0 from "./IconChevronDown.vue?vue&type=style&index=0&id=4d24b944&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d24b944",
  null
  
)

export default component.exports